import { deleteExplicitCart } from "~/features/cart/cart/api/ClearCart";
import { resolveActiveCartResourceId } from "~/features/cart/cart/utils/cartResourceIdentity";

export async function send(): Promise<void> {
  const activeCartId = await resolveActiveCartResourceId();
  if (!activeCartId) {
    throw new Error("Cannot clear a quote without an explicit Active Cart identity");
  }
  await deleteExplicitCart(activeCartId);
}
